export default "__VITE_ASSET__CvJz93sc__"